import React, { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { Query } from 'react-apollo';
import Alert from '@material-ui/lab/Alert';
import Box from '@material-ui/core/Box';
import Button from 'components/common/Button';
import Spin from 'components/common/Spin';
import { GET_USER_ACCOUNT } from 'graphql/payments/account';

const ConnectAccount = ({}) => {
  const [link, setLink] = useState();
  const [account, setAccount] = useState();
  useEffect(() => {
    API.post('api', '/stripe/connect/setup').then((data) => {
      setLink(data.url);
    });
    API.get('api', '/stripe/connect/account').then((data) => {
      setAccount(data);
    });
  }, []);

  return (
    <Box>
      <Query query={GET_USER_ACCOUNT}>
        {({ data, loading, error }) => {
          if (loading) return <Spin spinning />;
          if (error) return error.message;
          const { payment_accounts } = data;
          let enabled = false;
          let label = 'Setup Payment';
          if (payment_accounts.length && payment_accounts[0].payouts_enabled) {
            label = 'Update account';
            enabled = true;
          }

          let errorMessage = '';
          let pendingVerification = false;
          if (account) {
            if (account.requirements.disabled_reason) {
              if (
                account.requirements.disabled_reason ===
                'requirements.pending_verification'
              ) {
                pendingVerification = true;
              } else {
                errorMessage =
                  'We need few more information in order to verify your account.';
                label = 'Verify account';
              }
            }
          }

          return (
            <>
              {errorMessage && <Alert color="error">{errorMessage}</Alert>}
              {enabled && (
                <Alert>
                  Your account has been verified and enabled to receive payout.
                </Alert>
              )}
              {!pendingVerification && (
                <Box marginTop={2}>
                  <Button
                    onClick={() => window.location.replace(link)}
                    loading={!link}
                    color="primary"
                    variant="contained"
                  >
                    {label}
                  </Button>
                </Box>
              )}
              {pendingVerification && !enabled && (
                <Alert color="info">
                  Your account is under verification. Please check back later.
                </Alert>
              )}
            </>
          );
        }}
      </Query>
    </Box>
  );
};

export default ConnectAccount;
